import * as t from 'io-ts';
export var StringOperator = t.keyof({
  $exact: 'exact string match',
  $substring: 'substring of'
}, 'StringOperator');
export var NumberOperator = t.keyof({
  $gt: 'greater than',
  $gteq: 'greater than or equal to',
  $lteq: 'less than or equal to',
  $lt: 'less than'
}, 'NumberOperator');
export var ArrayOperator = t.keyof({
  $exact_in: 'exact match in array',
  $substring_in: 'string of array item'
}, 'ArrayOperator');
export var TimeOperator = t.keyof({
  $before: 'before a time',
  $after: 'after a time'
}, 'TimeOperator');
export var Operator = t.union([NumberOperator, StringOperator, ArrayOperator, TimeOperator]);